import debug from 'bows';
import ClipboardJS from 'clipboardjs';
import Tooltip from './_tooltip';

const log = debug('clipboard');

export default class {
	constructor( selector ) {
		this.selector = selector;

		if ( ! ClipboardJS.isSupported() ) {
			return;
		}

		this._clipboardjs = new ClipboardJS(this.selector);

		this._clipboardjs.on('success', (e) => {
			log('clipboard copied', e);

			new Tooltip({
				node: e.trigger,
				text: e.trigger.dataset['clipboard-tooltip'] || 'Copied!',
				duration: parseInt( e.trigger.dataset['clipboard-tooltip-duration'], 10 ) || 1500
			});
		});

		this._clipboardjs.on('error', (e) => {
			log('error', e);
		});

		log(this);
	}
}
